module.exports = {
  "/": {
    "name": "homePage",
    "success": {
      "default": [
        "HOME_PAGE_LOADED"
      ]
    }
  },
  "/tests/:websiteUrl": {
    "name": "resultsPage",
    "success": {
      "results loaded": [
        "RESULTS_PAGE_LOADED"
      ],
      "loading state": [
        "GRADING_IN_PROGRESS"
      ]
    }
  },
  "/widget/tests/:websiteUrl": {
    "name": "widgetResultsPage",
    "success": {
      "widget results loaded": [
        "WIDGET_RESULTS_PAGE_LOADED"
      ],
      "widget loading state": [
        "WIDGET_GRADING_IN_PROGRESS"
      ]
    }
  },
  "/error/:errorType": {
    "name": "errorPage",
    "success": {
      "error page loaded": [
        "ERROR_PAGE_LOADED"
      ]
    }
  },
  "/widget/error/:errorType": {
    "name": "widgetErrorPage",
    "success": {
      "widget error page loaded": [
        "WIDGET_ERROR_PAGE_LOADED"
      ]
    }
  }
};